export const formatDisplayPrice = (price, currency, formatOptions) => {
    return formatPrice(price, currency, {
        ...formatOptions,
        showCents: false,
    });
};
export const formatCartPrice = (price, currency, formatOptions) => {
    return formatPrice(price, currency, {
        ...formatOptions,
        showCents: true,
        roundUp: false,
    });
};
const generateFormattingLocale = (currency, language, country) => {
    const countryPriceFormatOverrides = {
        es: { default: 'US', eur: 'ES' },
        it: { default: 'IT' },
        pt: { default: 'PT' },
    };
    // forcedFormattingCountry is built to achieve ideal price formatting for the new latin langs (es, it, pt)
    // Locale here is not representative of users actual locale. (Example: pt-EU (€ 12) becomes pt-PT (12 €))
    let locale = country && language ? `${language}-${country}` : language;
    if (['es', 'it', 'pt'].includes(language ?? '')) {
        const forcedFormattingCountry = countryPriceFormatOverrides[language ?? ''][currency] ??
            countryPriceFormatOverrides[language ?? ''].default;
        locale = `${language}-${forcedFormattingCountry}`;
    }
    return locale;
};
export const formatPrice = (price, currency, formatOptions) => {
    const { country, language, inCents = true, roundUp = false, showCents, } = formatOptions ?? {};
    let priceInDollars = inCents ? Math.round(price) / 100 : price;
    if (!showCents && roundUp) {
        priceInDollars = Math.ceil(priceInDollars);
    }
    const fractionDigits = showCents || priceInDollars % 1 !== 0 ? 2 : 0;
    const locale = generateFormattingLocale(currency, language, country);
    return Intl.NumberFormat(locale, {
        currency,
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits,
        style: 'currency',
    }).format(priceInDollars);
};
export const splitPrice = ({ country, currency, formattedPrice, language, }) => {
    const locale = generateFormattingLocale(currency, language, country);
    const decimalSeparator = Intl.NumberFormat(locale, { currency, style: 'currency' })
        .formatToParts(1.1)
        .find((part) => part.type === 'decimal')?.value || '.';
    return {
        dollarAmount: formattedPrice.split(decimalSeparator)[0],
        centsAmount: formattedPrice.split(decimalSeparator)[1],
        decimalSeparator,
    };
};
